<div class="ag-form-control" #viewControl matTooltip="{{ !!hint && control.invalid && control.dirty ? hint : null }}" [class.has-errors]="control.invalid && control.dirty" [class.disabled]="control.disabled">
  <div class="ag-value">
    <input type="text" [formControl]="control" placeholder=" " (focus)="handleInputFocus($event)" (keydown)="handleKeydown($event)" (mouseup)="handleClickFocus($event)" (input)="handleUserInput($event)" (blur)="handleInputBlur($event)" #inputField />
    <label for="value">{{ label }}</label>
  </div>
</div>
